import styled from 'styled-components';

export const ModalContainer = styled.div`
  background-color: #ffffff;
  border-radius: 12px;
  padding: 30px;
  width: 780px;
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: 'Inter', sans-serif;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-weight: 700;
  color: #333;
  margin: 0 0 10px 0;
`;

export const Subtitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 30px 0;
`;

export const TableTitle = styled.h4`
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
`;

export const Th = styled.th`
  padding: 12px 8px;
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: #666;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    text-align: center;
  }
  
  &:nth-child(2) {
    text-align: left;
  }
`;

export const Td = styled.td`
  padding: 12px 8px;
  text-align: center;
  font-size: 13px;
  color: #666;
  border-bottom: 1px solid #e0e0e0;

  &:first-child {
    text-align: center;
  }

  &:nth-child(2) {
    text-align: left;
  }
`;

export const ItemRow = styled.tr<{ $inelegivel?: boolean }>`
  opacity: ${({ $inelegivel }) => ($inelegivel ? 0.6 : 1)};
`;

export const MotivoInelegibilidade = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 11px;
  font-style: italic;
  color: #999;
`;

export const DescricaoRiscada = styled.span`
  text-decoration: line-through;
`;

export const BadgesRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
`;

export const BadgePendencia = styled.span<{ $bloqueante?: boolean }>`
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  font-weight: 600;
  white-space: nowrap;
  cursor: default;
  background-color: ${({ $bloqueante }) => ($bloqueante ? '#FCE8E6' : '#FDF3DC')};
  color: ${({ $bloqueante }) => ($bloqueante ? '#B3261E' : '#9A6A00')};
`;

export const ValorFixo = styled.span`
  display: inline-block;
  min-width: 90px;
  text-align: right;
  font-size: 13px;
  color: #333;
  font-variant-numeric: tabular-nums;
`;

export const Legenda = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 10px;
  font-size: 11px;
  color: #777;
`;

export const LegendaItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
`;

export const LegendaDot = styled.span<{ $bloqueante?: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ $bloqueante }) => ($bloqueante ? '#B3261E' : '#D19C00')};
`;

export const CheckboxInput = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #0090d3;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const QtdInput = styled.input`
  width: 70px;
  min-width: 70px;
  box-sizing: border-box;
  padding: 6px 10px;
  text-align: center;
  border: 1px solid #d0d0d0;
  border-radius: 100px;
  background-color: transparent;
  color: #333;
  font-size: 13px;

  /* Hide arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ValorInput = styled.input`
  width: 130px;
  min-width: 130px;
  box-sizing: border-box;
  padding: 6px 12px;
  text-align: right;
  border: 1px solid #d0d0d0;
  border-radius: 100px;
  background-color: transparent;
  color: #333;
  font-size: 13px;

  /* Hide arrows */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  -moz-appearance: textfield;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const CancelButton = styled.button`
  background: none;
  border: 1px solid #0090d3;
  color: #0090d3;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
`;

export const ConfirmButton = styled.button`
  background-color: #0090d3;
  border: none;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 100px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
